<template>
    <div>
        <b-row>
            <b-col md="9" sm="12">
                <div class="row">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">{{ $t('partido.elige_asientos') }}</h2>
                        <h3 class="subtitle h3 light mb-3 ">{{ $t('partido.varios_asientos') }}</h3>
                    </div>
                    <b-col cols="12">
                        <TerrenoJuegoComponent/>
    
                        <SelectorAsientosComponent
                            :loading="false"
                            :filas="seat_map"
                            :print_align="zona_seleccionada.print_align"
                            :front="true"
                            @butacaSeleccionada="toggleSeleccion"
                        />
                    </b-col>
                </div>
            </b-col>
            <b-col md="3" sm="12" class="ml-3 ml-md-0">
                <div class="oswald text-uppercase">{{ $t('partido.zona_seleccionada') }}:</div>
                <span class="h2 mb-1 d-block">
                    {{ zona_seleccionada.name }}
                    <br>
                    <button
                        v-if="zonas_disponibles.length > 1"
                        class="h6 button small-button m-0"
                        :disabled="false"
                        @click="resetAsientos"
                    >
                        <i class="fa fa-redo"></i> {{ $t('partido.cambiar_zona') }}
                    </button>
                    <button
                        v-if="zona_seleccionada.imagen_panoramica"
                        type="button"
                        class="h6 button small-button m-0 ml-2"
                        @click="$modal.show('imagen-panoramica')"
                    >
                        VER 360º
                    </button>
                </span>
                <ImagenPanoramica
                    v-if="zona_seleccionada.imagen_panoramica"
                    name="imagen-panoramica"
                    :url="zona_seleccionada.imagen_panorama"
                    title="Imagen panorámica de la zona"
                    @close="() => close(false)"
                />
    
                <div v-if="zona_seleccionada.imagen" class="mb-3"><img :src="zona_seleccionada.imagen"></div>
    
                <label class="mt-3">{{ $t('nuevo_abono.tus_asientos') }}</label>
    
                <div style="max-height: 500px; overflow-y: auto;">
                    <div v-for="(asiento, index) in asientosSeleccionados" :key="index" class="lightgray-content mb-3">
                        <div class="text-bold mb-2 d-md-flex p-3">
                            <div class="oswald">
                                {{ (num = index + 1) }}.
                            </div>
                            <div class="ml-2">
                                <small v-if="asiento.asiento.fila">
                                    {{ $t("general.fila") }}: {{ asiento.asiento.fila }}
                                </small>
                                <small v-if="asiento.asiento.asiento">
                                    {{ $t("general.butaca") }}: {{ asiento.asiento.asiento }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
                <b-button class="mb-3" block v-if="asientosSeleccionados.length > 0" @click="continuar()">Continuar</b-button>
            </b-col>
        </b-row>
        <section v-if="reserva.comprar_completa" class="padding-vertical-content lightgray-content">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h1>{{ $t('afiliados.entradas_preseleccionadas') }}</h1>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import TerrenoJuegoComponent from '@/components/common/Asientos/TerrenoJuegoComponent.vue';
import SelectorAsientosComponent from '@/components/common/Asientos/SelectorAsientosComponent.vue';
import ImagenPanoramica from "@/components/common/ImagenPanoramica";

export default {
    props: {
        reserva: {
            type: Object,
            required: true
        },
        zona_seleccionada: {
            type: Object,
            required: true
        },
        seat_map: {
            type: Object,
            required: true
        },
        asientos: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            asientosSeleccionados: [...this.asientos]
        };
    },
    watch: {
        asientos: {
            handler(nuevosAsientos) {
                this.asientosSeleccionados = [...nuevosAsientos];
            },
            deep: true,
            immediate: true
        },
    },
    methods: {
        toggleSeleccion(fila, butaca) {
            let asientoSeleccionado = this.asientosSeleccionados.findIndex(item => item.asiento.asiento === butaca && item.asiento.fila == fila);

            if (asientoSeleccionado !== -1) {
                this.asientosSeleccionados.splice(asientoSeleccionado, 1);
            } else {
                if (this.asientosSeleccionados.length >= this.reserva.evento.n_max_asientos) {
                    return this.$toast.error(this.$t('afiliados.limite_asientos', { 'asientos': this.reserva.evento.n_max_asientos }));
                }

                let asiento_original = this.reserva.butacas.find(item => item['asiento'] === butaca && item['fila'] == fila && item['zona_id'] == this.zona_seleccionada.id);

                if (asiento_original) {
                    this.asientosSeleccionados.push({
                        asiento: asiento_original,
                        precios: asiento_original.precios,
                        descuento: this.reserva.descuento,
                        precio: asiento_original.precio
                    });
                }
            }

            this.seat_map[fila].forEach(asiento => {
                if (asiento.asiento === butaca && !asiento.ocupado) {
                    asiento.seleccionado = !asiento.seleccionado;
                }
            });

            this.$emit('update:asientos', [...this.asientosSeleccionados]);
        },
        resetAsientos() {
            if (!this.reserva.comprar_completa) {
                this.$emit('resetAsientos');
            }            
        },
        continuar() {
            this.$emit('asientosSeleccionados');
        }
    },
    computed: {
        zonas_disponibles() {
            return this.reserva.zonas.filter(zona => zona.esta_disponible);
        }
    },
    components: {
        TerrenoJuegoComponent, SelectorAsientosComponent, ImagenPanoramica
    }
}
</script>